module.exports = __webpack_public_path__ + "img/phone.51617c90.png";